<template>
  <div>
    <div class="ibox">
      <div class="ibox-title" v-if="placements[0]">
        Placements
        <a class="btn btn-primary btn-xs pull-right" :href="'http://188.166.96.115/link-pyramid/' + placements[0].pyramid + '/deployments?type=csv'">Export CSV</a>
      </div>
      <div class="ibox-content">
        <div class="row m-b-sm m-t-sm">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Tier</th>
              <th>#</th>
              <th>Deployed</th>
              <th>Link</th>
              <th>Anchor</th>
              <th>Post</th>
              <th>Site</th>
              <th>DA</th>
              <th>RD</th>
              <th>TF</th>
              <th>Status</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(placement, i) in placements" :key="placement.id" class="tierTr">
              <td>{{ tiers[placement.tier]['level'] }}</td>
              <td>{{ i + 1 }}</td>
              <td><span v-if="placement.deployed">{{ $moment(placement.deployed.date).format('DD.MM. HH:mm') }}</span></td>
              <td><span :title="placement.url" v-if="placement.url">{{ placement.url.substr(0, 25) }}...</span></td>
              <td>{{ placement.anchor.substr(0, 25) }}</td>
              <td><a v-if="placement.postData.title" :href="placement.postData.link" rel="noreferrer" :title="placement.postData.title">{{ placement.postData.title.substr(0, 30) }}...</a></td>
              <td>
                <span v-if="placement.postData.siteUrl">{{ placement.postData.siteUrl }}</span>
                <span v-else-if="placement.status === 'DEPLOYED'">
                  <i>Old replacement</i>
                </span>
                <span v-else>&nbsp;</span></td>
              <td><span v-if="placement.postData.stats && placement.postData.stats.da">{{ placement.postData.stats.da }}</span><span v-else><i>/</i></span></td>
              <td><span v-if="placement.postData.stats && placement.postData.stats.rd">{{ placement.postData.stats.rd }}</span><span v-else><i>/</i></span></td>
              <td><span v-if="placement.postData.stats && placement.postData.stats.tf">{{ placement.postData.stats.tf }}</span><span v-else><i>/</i></span></td>
              <td>
                <span v-if="placement.status === 'DEPLOYED'">
                  <i class="fa fa-check-circle" :title="placement.status" style="color: forestgreen"></i>
                  <i v-if="placement.realCheck" class="fa fa-star" title="Real check successful" style="color: forestgreen"></i>
                  <i v-else class="fa fa-star-half-empty"  style="color: orangered" title="Real check failed"></i>
                  <i class="fa fa-recycle" title="Replace" style="color:forestgreen; cursor:pointer" @click="redeploy(placement.id, i)"></i>
                </span>
                <span v-else-if="placement.status === 'REDEPLOY'">
                  <i class="fa fa-recycle" :title="placement.status" style="color: orangered"></i>
                </span>
                <span v-else>
                  <i class="fa fa-clock-o" :title="placement.status" style="color:orangered"></i>
                </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      name: 'deployments'
    }
  },
  props: [
    'placements',
    'tiers'
  ],
  methods: {
    redeploy (id, i) {
      this.$swal({
        title: 'Replace deployment?',
        text: 'Once you confirm this there\'s no way back!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Do it!'
      }).then(r => {
        if (r.value) {
          axios.patch('/link-pyramid/deployment/' + id)
            .then(r => {
              this.placements[i].status = 'REDEPLOY'
            })
            .catch(e => {
              console.log(e)
            })
        }
      })
    },
    reCheck (id) {
      axios.get('/link-pyramid/deployment-check/' + id)
        .then(r => {
          console.log(r.data)
        })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/Apps/link-pyramid/Deployments.vue